<template>
  <div>
    <!--  @opened="$refs.typeSelect.init()" @closed="$refs.typeSelect.clear()" -->
    <common-dialog
      ref="dialog"
      width="850px"
      line-form
      unit="模具档案"
      edit-title
      id-key="MouldId"
      @opened="onOpened"
      :data="data"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :form-rules="rules"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @closed="toClosed"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-row>
          <el-col :span="12">
            <el-form-item label="模具编号" prop="MouldNo">
              <span v-if="Mode == 0" class="detail-span">{{ data.MouldNo }}</span>
              <el-input v-else v-model="data.MouldNo" placeholder="请输入模具编号"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="模具类别" prop="ClassId">
              <tree-select
                ref="treeSelect"
                :props="props"
                :options="TreeData"
                :value="data.ClassId"
                :clearable="false"
                :accordion="true"
                :parentSelect="true"
                placeholder="请选择"
                @node-select="onTreeSelect($event)"
              />
              <!-- <el-select v-model="data.ClassId">
                <el-option :value="0" label="类别1"></el-option>
                <el-option :value="1" label="类别2"></el-option>
                <el-option :value="2" label="类别3"></el-option>
              </el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="模具名称" prop="MouldName">
              <el-input type="text" v-model="data.MouldName"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="损耗%">
              <el-input type="number" v-model="data.Loss"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="模具重量">
              <el-input type="number" v-model="data.Weight" @change="changeWeight"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="重量单位" :prop="isWeight ? 'WeightUnitId' : ''">
              <el-select v-model="data.WeightUnitId" :disabled="true">
                <el-option v-for="item in unitList" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName"></el-option>
              </el-select>
              <!-- <unit-select v-model="data.WeightUnitId" :params="unitParams" /> -->
              <!-- <el-select v-model="data.WeightUnitId">
								<el-option :value="0" label="类别1"></el-option>
								<el-option :value="1" label="类别2"></el-option>
								<el-option :value="2" label="类别3"></el-option>
							</el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="每模毛重" prop="PerGrossWeight">
              <el-input type="number" v-model="data.PerGrossWeight"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="重量单位" prop="PerGrossWeightUnitId">
              <!-- <unit-select
                v-model="data.PerGrossWeightUnitId"
                @change="changePerGrossWeightUnitId"
                :params="unitParams"
              /> -->
              <el-select v-model="data.PerGrossWeightUnitId" :disabled="true">
                <el-option v-for="item in unitList" :key="item.UnitId" :value="item.UnitId" :label="item.UnitName"></el-option>
              </el-select>
              <!-- <el-select v-model="data.PerGrossWeightUnitId">
								<el-option :value="0" label="类别1"></el-option>
								<el-option :value="1" label="类别2"></el-option>
								<el-option :value="2" label="类别3"></el-option>
							</el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="每模净重" prop="PerNetWeight">
              <span style="padding: 0 15px">{{ data.PerNetWeight }}</span>
              <!-- <el-input type="number" v-model="data.PerNetWeight"></el-input> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="重量单位">
              <span style="padding: 0 15px">{{ data.PerNetWeightUnitName }}</span>
              <!-- <unit-select
                v-model="data.PerNetWeightUnitId"
                :params="unitParams"
              /> -->
              <!-- <el-select v-model="data.PerNetWeightUnitId">
								<el-option :value="0" label="类别1"></el-option>
								<el-option :value="1" label="类别2"></el-option>
								<el-option :value="2" label="类别3"></el-option>
							</el-select> -->
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="1出几套" prop="Afew">
              <el-input type="number" v-model="data.Afew" @change="changeAfew"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="1出几款" prop="Styles">
              <el-input type="number" v-model="data.Styles"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="状态" prop="Status">
              <el-select v-model="data.Status">
                <el-option :value="0" label="停用"></el-option>
                <el-option :value="1" label="待用"></el-option>
                <el-option :value="2" label="在用"></el-option>
                <el-option :value="3" label="维修"></el-option>
                <el-option :value="4" label="报废"></el-option>
                <el-option :value="5" label="出售"></el-option>
              </el-select>
            </el-form-item>
          </el-col>

          <el-col :span="12">
            <el-form-item label="生产类型" prop="MouldNature">
              <el-select v-model="data.MouldNature">
                <el-option :value="0" label="自制"></el-option>
                <el-option :value="1" label="委外"></el-option>
                <el-option :value="2" label="自制&委外"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>

        <el-tabs v-model="activeName">
          <el-tab-pane label="基础信息" name="tab1">
            <el-row>
              <el-col :span="12">
                <el-form-item label="替换模具">
                  <mould-select v-model="data.ReplaceMouldId"></mould-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="加工单价">
                  <el-input type="number" v-model="data.Price"></el-input>
                </el-form-item>
              </el-col>

              <!-- h -->
              <!-- <el-col :span="12">
                <el-form-item label="仓库">
                  <wms-select v-model="data.WarehouseId"></wms-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="库位">
                  <el-input type="text" v-model="data.StorageBin" />
                </el-form-item>
              </el-col> -->
              <!-- h -->

              <el-col :span="12">
                <el-form-item label="机台机型">
                  <el-autocomplete class="inline-input" v-model="data.MachineType" :fetch-suggestions="querySearchMachineType" placeholder="请输入内容" @select="selectMachineType"></el-autocomplete>
                </el-form-item>
              </el-col>
                            
              <!-- h -->
              <!-- <el-col :span="12">
                <el-form-item label="制造商">
                  <el-autocomplete class="inline-input" v-model="data.Manufacturer" :fetch-suggestions="querySearchTradeUnit" placeholder="请输入内容"></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="维修商">
                  <el-autocomplete class="inline-input" v-model="data.Repairer" :fetch-suggestions="querySearchTradeUnit" placeholder="请输入内容"></el-autocomplete>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="加工商">
                  <el-select v-model="data.Converter" clearable @change="changeConverter">
                    <el-option v-for="item in tradeUnitList" :key="item.TradeUnitId" :value="item.FullName" :label="item.FullName"></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <!-- h -->

              <el-col :span="12">
                <el-form-item label="标准产出量" prop="">
                  <el-input type="number" v-model="data.StandardOutput"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="原值">
                  <el-input type="number" v-model="data.OriginalValue"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item label="按模入库" prop="IsModulo">
                  <el-select v-model="data.IsModulo">
                    <el-option :value="true" label="是"></el-option>
                    <el-option :value="false" label="否"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>

              <!-- h -->
              <!-- <el-col :span="12">
                //累计产出量取报工单数带入
                <el-form-item label="累计产出量">
                  {{ data.TotalOutput }}
                </el-form-item>
              </el-col> -->
              <!-- h -->


              <!-- <el-col :span="12">
                <el-form-item label="默认供应商">
                  <el-select v-model="data.DefaultSupplier" clearable>
                    <el-option
                      v-for="item in tradeUnitList"
                      :key="item.TradeUnitId"
                      :value="item.TradeUnitId"
                      :label="item.FullName"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->

              <el-col :span="24">
                <el-form-item label="备注">
                  <el-input type="textarea" class="taborder" v-model="data.Remark"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </el-tab-pane>
          <!-- h -->
          <!-- <el-tab-pane label="胶件列表" name="tab2">
            <div class="row-tb-head" style="margin-top: 10px">
              <span>产出胶件半成品</span>
            </div>
            <el-table title="产出胶件半成品" :data="Pus" ref="tableList" border>
              <el-table-column prop="ProductName" label="半成品名称" min-width="110" align="center"> </el-table-column>
              <el-table-column prop="ProductNo" label="半成品编号" min-width="110" align="center"> </el-table-column>
              <el-table-column prop="Quantity" label="数量" min-width="110" align="center"> </el-table-column>
              <el-table-column prop="Weight" label="单重" min-width="110" align="center"> </el-table-column>
            </el-table>
          </el-tab-pane> -->
          <!-- h -->
          <el-tab-pane label="生产工艺参数" name="tab3">
            <el-table title="工艺参数" :data="ProductData" ref="tableList" border>
              <el-table-column prop="CreateTime" label="时间" min-width="110" align="center"> </el-table-column>
              <el-table-column prop="WorkDocNo" label="注塑工单" min-width="110" align="center"> </el-table-column>
              <el-table-column prop="CraftRecType" label="类型" min-width="110" align="center">
                <template slot-scope="{ row }">
                  <span v-if="row.CraftRecType == 0">最大模数</span>
                  <span v-if="row.CraftRecType == 1">最新</span>
                </template>
              </el-table-column>
              <el-table-column label="详细数据" min-width="110" align="center">
                <template slot-scope="{ row }">
                  <el-button type="success" @click="showDetail(row)">查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </el-tab-pane>
        </el-tabs>
      </template>
      <template slot="footer">
        <el-button type="primary" @click="toSave">保存</el-button>
        <el-button @click.stop="close">关 闭</el-button>
      </template>
    </common-dialog>
    
    <edit-dialog ref="editDialog" @close-saved="reload"></edit-dialog>
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import typeSelect from './type/select'

import mouldSelect from './select'
import wmsSelect from '@/components/basedata/basedoc/wms/select'
import treeSelect from '@/components/common/treeSelect'
import productSelect from '@/components/basedata/inventory/archives/select'
import unitSelect from '@/components/basedata/inventory/unit/select'
import editDialog from '@/components/facility/equipment/craftdata/editDialog'

export default {
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    typeSelect,
    mouldSelect,
    wmsSelect,
    treeSelect,
    productSelect,
    unitSelect,
    editDialog
  },
  data() {
    return {
      Pus: [],
      data: {
        WarehouseId: null,
        WarehouseNo: '',
        WarehouseName: '',
        WarehouseType: 0, //仓库类型 - 0:库存仓 1:生产仓
        ClassId: null,
        ClassName: '',
        Remark: '',
        Sn: 0,
        Status: 2, // <!-- h -->
        IsModulo: true,
        IsNetWeight: true,
        DefaultSupplier: 0,
        MouldNature: 0, // <!-- h -->
        Weight: null,
        Remark: '',
        StorageBin: '',
        MouldNo: null,
        PerGrossWeight: 0, // 初始化为数字
        PerNetWeight: 0 // 初始化为数字
      },

      Mode: 1,
      unitApi: require('@/api/ba/unit').default,
      code_api: require('@/api/sy/serialCode').default,
      api: require('@/api/ba/mould').default,
      classApi: require('@/api/ba/class').default,
      productApi: require('@/api/ba/product').default,
      // 默认供应商
      tradeUnitApi: require('@/api/ba/tradeUnit').default,
      equipmentApi: require('@/api/ba/equipment').default,
      craftsumApi: require('@/api/equipment/craftsum').default,
      TreeData: [],
      productList: [],
      props: {
        value: 'ClassId',
        label: 'ClassName',
        children: 'children'
      },
      unitParams: {
        UnitGroupId: null,
        IsGroup: false
      },
      unitList: [], // 单位列表
      tradeUnitList: [],
      tradeUnitValueList: [], //构造有value值的供应商列表
      equipmentList: [], // 设备列表
      equipmentValueList: [], // 构造有value值的设备列表
      activeName: 'tab1', // 当前页签，默认基础信息
      unitId: null,
      unitName: '',
      isWeight: false,
      rules: {
        MouldNo: [{ required: true, message: '模具编号不能为空' }],
        PerGrossWeightUnitId: [{ required: true, message: '重量单位不能为空', trigger: 'blur' }],
        PerGrossWeight: [{ required: true, message: '每模毛重不能为空' }],
        WeightUnitId: [{ required: true, message: '重量单位不能为空' }],
        ClassId: [{ required: true, message: '模具类别不能为空' }],
        MouldName: [{ required: true, message: '模具名称不能为空' }],
        Afew: [{ required: true, message: '1出几套不能为空' }],
        Styles: [{ required: true, message: '1出几款不能为空' }],
        MouldNature: [{ required: true, message: '生产类型不能为空' }],
        Status: [{ required: true, message: '状态不能为空' }]
      },
      ProductData: []
    }
  },
  computed: {},
  methods: {
      showDetail(row){
      this.$refs.editDialog.openDetails(row);
    },
    changeAfew(val) {
      console.log(val, 'aad')
      if (val) {
        var qMachine = this.equipmentList.find(x => x.EquipmentName == this.data.MachineType)
        if (qMachine) {
          this.data.StandardOutput = qMachine.CycleOutPut * val
        }
      }
    },
    selectMachineType(val) {
      console.log(val, this.data, 'aa')
      if (val) {
        if (val.CycleOutPut > 0 && this.data.Afew > 0) {
          this.data.StandardOutput = val.CycleOutPut * this.data.Afew
        } else {
          this.data.StandardOutput = null
        }
      }
    },
    serialCode() {
      this.code_api.previewNo('模具').then(res => {
        console.log('serialType', res)
        if (res.Code == 0) {
          this.Mode = res.Data.Mode
          this.data.MouldNo = res.Data.PreviewNo
        } else {
          this.$message.warning('获取模具编号失败')
        }
      })
    },
    onOpened() {
      this.getProductData()
    },
    changeWeight(data) {
      if (data) {
        this.isWeight = true
        this.data.WeightUnitId = this.unitId
        this.data.WeightUnitName = this.unitName
        console.log('this.data.WeightUnitId', this.data.WeightUnitId)
      } else {
        this.isWeight = false
        this.data.WeightUnitId = null
        this.data.WeightUnitName = ''
      }
    },
    // 修改毛重重量单位同步修改净重重量单位
    changePerGrossWeightUnitId(data) {
      if (this.data.PerNetWeight) {
        this.data.PerNetWeightUnitId = data.UnitId
        this.data.PerNetWeightUnitName = data.UnitName
      }
    },
    querySearchTradeUnit(queryString, cb) {
      var restaurants = this.tradeUnitValueList
      var results = queryString ? restaurants.filter(this.createFilterTradeUnit(queryString)) : restaurants

      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilterTradeUnit(queryString) {
      return restaurant => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    querySearchMachineType(queryString, cb) {
      var restaurants = this.equipmentValueList
      var results = queryString ? restaurants.filter(this.createFilterMachineType(queryString)) : restaurants

      // 调用 callback 返回建议列表的数据
      cb(results)
    },
    createFilterMachineType(queryString) {
      return restaurant => {
        return restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0
      }
    },
    onCreateOpened(data) {
      this.serialCode()
      this.classApi.list({ ClassType: 13 }).then(res => {
        this.TreeData = this.$commonJs.toTreeData(res.Data, 'ClassId')
        if (data.ClassId > 0) {
          this.$refs.treeSelect.setData(data.ClassId)
        }
      })
      this.api.getMaxSn().then(res => {
        this.data.Sn = res
      })
    },
    onEditOpened(data) {
      this.api.info(data.MouldId).then(res => {
        this.data = res.Data
        this.Pus = res.Data.Rubbers.map(item => ((item.T = 3), item))

        let length = this.Pus.length
        let sum = 0
        for (let i = 0; i < length; ++i) {
          sum = sum + this.Pus[i].Weight * this.Pus[i].Quantity
        }
        this.data.PerNetWeight = parseFloat(sum.toFixed(2))

        this.data.PerNetWeightUnitId = this.data.PerNetWeightUnitId ?? this.data.PerGrossWeightUnitId
        this.data.PerNetWeightUnitName = this.data.PerNetWeightUnitName ?? this.data.PerGrossWeightUnitName
        this.data.ReplaceMouldId = this.data.ReplaceMouldId !== 0 ? this.data.ReplaceMouldId : null
        this.data.Price = this.data.Price !== 0 ? this.data.Price : null

        this.getTreeData()
        // this.$refs.treeSelect.setData(res.Data.ClassId);
      })
      this.craftsumApi.list({ CraftMouldNo: this.data.MouldNo }).then(res => {
        console.log(this.data.MouldNo,"aa");
        this.ProductData = res.Data
      })
    },
    add() {
      this.Pus.push({
        ProductId: null,
        ProductName: null,
        ProductNo: null,
        Quantity: null,
        Weight: null
      })
    },
    onTreeSelect(t) {
      if (!t) {
        this.data.ClassName = ''
        this.data.ClassId = null
        // this.data.CarId = null;
        // this.data.CarNo = null;
      } else {
        this.data.ClassName = t.ClassName
        this.data.ClassId = t.ClassId
        this.data.IdChain = t.IdChain
      }
    },
    // 加工商选择，将id赋值到默认供应商里
    changeConverter(val) {
      let id = this.tradeUnitList.filter(item => item.FullName === val)[0]?.TradeUnitId
      if (id) {
        this.data.DefaultSupplier = id
      } else {
        this.data.DefaultSupplier = 0
      }
    },
    getProductData() {
      this.productApi.productList({ ProductType: 2 }).then(res => {
        // resolve(res);
        this.productList = res.Data
      })

      this.unitApi.list({ UnitGroupId: null, IsGroup: false, Status: 1 }).then(res => {
        if (res.Code === 0) {
          this.unitList = res.Data

          let list = res.Data.filter(item => {
            return item.UnitName === '克'
          })

          console.log('list', list)

          if (list == null || list.length === 0) {
            this.$message.warning('请先在计量单位创建单计量单位克')

            return
          } else {
            let item = list[0]

            this.unitId = item.UnitId
            this.unitName = item.UnitName

            if (this.data.Weight) {
              this.data.WeightUnitId = item.UnitId
              this.data.WeightUnitName = item.UnitName
            }

            this.data.PerGrossWeightUnitId = item.UnitId
            this.data.PerGrossWeightUnitName = item.UnitName

            this.data.PerNetWeightUnitId = item.UnitId
            this.data.PerNetWeightUnitName = item.UnitName
          }

          // PerGrossWeightUnitId WeightUnitId PerNetWeightUnitId
        }
      })

      this.tradeUnitApi.list({ TradeUnitTypes: [1, 3] }).then(res => {
        this.tradeUnitList = res.Data

        this.tradeUnitValueList = res.Data.map(item => {
          return {
            value: item.FullName,
            ...item
          }
        })
        // console.log("默认供应商");
        // console.log(this.tradeUnitList);
      })

      this.equipmentApi.list({ Statuses: [1, 2] }).then(res => {
        this.equipmentList = res.Data
        this.equipmentValueList = res.Data.map(item => {
          return {
            value: item.EquipmentName,
            ...item
          }
        })
      })
    },
    getTreeData() {
      this.classApi.list({ ClassType: 13 }).then(res => {
        this.TreeData = this.$commonJs.toTreeData(res.Data, 'ClassId')
        if (this.data.ClassId > 0) {
          this.$refs.treeSelect.setData(this.data.ClassId)
        }
      })
    },
    mouldChange(data, index) {
      console.log('pus', this.Pus)
      console.log('data', data)
      let ids = this.Pus.map(i => i.ProductId)
      if (ids.includes(data.ProductId)) this.$message.warning('列表中已存在相关产品')
      // this.$refs.tableList.data[index].ProductNo = data.ProductNo
      // this.$refs.tableList.data[index].ProductId = data.ProductId
      this.Pus[index].ProductNo = !ids.includes(data.ProductId) ? data.ProductNo : null
      this.Pus[index].ProductId = !ids.includes(data.ProductId) ? data.ProductId : null
      this.Pus[index].ProductName = !ids.includes(data.ProductId) ? data.ProductName : null
      this.changT(data, index)
    },
    changT(data, index) {
      if (this.Pus[index].T === 3) this.Pus[index].T = 1
    },
    // onBeforeSave() {
    //   this.Pus = this.Pus.filter((i) => i.ProductId !== null);
    //   console.log("Pus", this.Pus);
    //   if (this.data.Rubbers.length == 0) {
    //     this.data.Rubbers = this.$refs.tableList.data.map(
    //       (item) => ((item.T = 0), item)
    //     );
    //   } else {
    //     let delIds = this.Pus.map((item) => item.ProductId);
    //     let delList = this.data.Rubbers.reduce((arr, item) => {
    //       if (!delIds.includes(item.ProductId)) arr.push({ ...item, T: 2 });
    //       return arr;
    //     }, []);

    //     let addIds = this.data.Rubbers.map((item) => item.ProductId);
    //     let addList = [];
    //     addList = this.Pus.reduce((arr, item) => {
    //       if (!addIds.includes(item.ProductId)) arr.push({ ...item, T: 0 });
    //       return arr;
    //     }, []);
    //     let updateList = this.Pus.filter((i) => i.T == 1);
    //     this.data.Rubbers = [...addList, ...delList, ...updateList];
    //   }
    // },
    onBeforeSave() {
      if (this.data.PerGrossWeight < this.data.PerNetWeight) {
        this.$message.error('不允许每模毛重<每模净重，请重新填写')
        return false
      }
    },
    toClosed() {
      this.Pus = []
      this.TreeData = []
      this.productList = []
      this.$refs.treeSelect.clearHandle()
      // this.data = {}
      Object.assign(this.$data, this.$options.data())
    },
    toSave() {
      if (this.Pus.length > this.data.Styles) {
        this.$confirm('产出胶件数量大于1出几款，确定保存', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
          .then(() => {
            this.doSave()
          })
          .catch(() => {})
      } else {
        this.doSave()
      }
    },
    doSave() {
      let data = this.$commonJs.obj.removeNullKey(this.data)
      this.api.save(data).then(res => {
        if (res.Code == 0) {
          this.$message.success(res.Msg)
          this.$emit('close-saved')
          this.close(true)
        } else {
          this.$message.error(res.Msg)
        }
      })
    }
  }
}
</script>
